module.exports = __webpack_public_path__ + "static/media/Brands_14.8f7c86e1.png";